import React from "react";
import { Form, Input, Button, Select, message } from "antd";
import styles from "./styles.module.css";
import { sendContractOrder } from '../../../util/auth';

const Option = Select.Option;
const { TextArea } = Input;

class AppForContractForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      captchaA: 0,
      captchaB: 0,
      userCaptchaInput: "",
      isCaptchaNull: true,
    };

    this.onCaptchaChange = this.onCaptchaChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.hasErrors = this.hasErrors.bind(this);
    this.generateCaptcha = this.generateCaptcha.bind(this);
  }

  componentDidMount() {
    this.props.form.validateFields();
    this.generateCaptcha();
  }

  generateCaptcha = () => {
    const a = Math.floor(Math.random() * 20) + 1;
    const b = Math.floor(Math.random() * 20) + 1;
    this.setState({
      captchaA: a,
      captchaB: b,
      userCaptchaInput: "",
      isCaptchaNull: true,
    });
  };

  onCaptchaChange = (e) => {
    const value = e.target.value;
    const correctAnswer = this.state.captchaA + this.state.captchaB;
    const isCorrect = parseInt(value, 10) === correctAnswer;
    this.setState({
      userCaptchaInput: value,
      isCaptchaNull: !isCorrect,
    });
  };

  sendForm(opts) {
    sendContractOrder(opts, () => {
      message.success("Заявка отправлена");
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      const isCaptchaValid = !this.state.isCaptchaNull;
      if (!err && isCaptchaValid) {
        const result = { ...values };
        result.TariffPlan = Array.isArray(values.TariffPlan)
          ? values.TariffPlan[0]
          : values.TariffPlan;
        this.sendForm(result);
        this.props.form.resetFields();
        this.generateCaptcha();
      } else {
        console.log("FORM NOT SENT");
      }
    });
  };

  hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
  }

  validateStatusGet(name, help) {
    const { isFieldTouched, getFieldError } = this.props.form;
    const itemStatus = isFieldTouched(name) && getFieldError(name);
    let val = "";

    if (help) {
      val = itemStatus || "";
    } else {
      val = itemStatus ? "error" : "";
    }

    return val;
  }

  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;

    const formItemLayout = null;
    const tailFormItemLayout = null;

    const tariffPlans = [
      <Option key="Контроль" value="Контроль">Контроль</Option>,
      <Option key="Базовый" value="Базовый">Базовый</Option>,
      <Option key="Учет" value="Учет">Учет</Option>
    ];

    return (
      <Form
        layout="vertical"
        onSubmit={this.handleSubmit}
        style={{ width: "46em", padding: "0em 1em 0em 1em" }}
      >
        <Form.Item
          {...formItemLayout}
          label="Название организации"
          validateStatus={this.validateStatusGet("CompanyName", false)}
          help={this.validateStatusGet("CompanyName", true)}
          className={styles.input}
        >
          {getFieldDecorator("CompanyName", {
            rules: [
              { type: "string", max: 250, message: "Неверный формат" },
              { required: true, message: "Введите название организации", whitespace: true }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label={<span>Контактное лицо</span>}
          validateStatus={this.validateStatusGet("ContactPerson", false)}
          help={this.validateStatusGet("ContactPerson", true)}
          className={styles.input}
        >
          {getFieldDecorator("ContactPerson", {
            rules: [
              { type: "string", max: 250, message: "Неверный формат" },
              { required: true, message: "Вы не указали контактное лицо", whitespace: true }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Телефон"
          validateStatus={this.validateStatusGet("PhoneNumber", false)}
          help={this.validateStatusGet("PhoneNumber", true)}
          className={styles.input}
        >
          {getFieldDecorator("PhoneNumber", {
            rules: [
              { type: "string", max: 250, message: "Неверный формат" },
              { required: true, message: "Введите телефон" }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Ваш E-mail"
          validateStatus={this.validateStatusGet("Email", false)}
          help={this.validateStatusGet("Email", true)}
          className={styles.input}
        >
          {getFieldDecorator("Email", {
            rules: [
              { type: "email", message: "Некорректный формат" },
              { required: true, message: "Введите Ваш E-mail" }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Абонентский номер узла учета, например, 1234/567"
          validateStatus={this.validateStatusGet("AbonMeterNumber", false)}
          help={this.validateStatusGet("AbonMeterNumber", true)}
          className={styles.input}
        >
          {getFieldDecorator("AbonMeterNumber", {
            rules: [
              { type: "string", max: 250, message: "Превышена максимальная длина" },
              { required: false, whitespace: true, message: "Одни лишь пробелы недопустимы" }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Тарифный план"
          validateStatus={this.validateStatusGet("TariffPlan", false)}
          help={this.validateStatusGet("TariffPlan", true)}
          className={styles.input}
        >
          {getFieldDecorator("TariffPlan", {
            initialValue: ["Контроль"],
            rules: [{ required: false }]
          })(<Select>{tariffPlans}</Select>)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Адрес узла учета тепла"
          validateStatus={this.validateStatusGet("HeatMeterAddress", false)}
          help={this.validateStatusGet("HeatMeterAddress", true)}
          className={styles.input}
        >
          {getFieldDecorator("HeatMeterAddress", {
            rules: [
              { type: "string", max: 800, message: "Превышена максимальная длина" },
              { required: false, whitespace: true, message: "Одни лишь пробелы недопустимы" }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="ИНН"
          validateStatus={this.validateStatusGet("INN", false)}
          help={this.validateStatusGet("INN", true)}
          className={styles.input}
        >
          {getFieldDecorator("INN", {
            rules: [
              {
                type: "string",
                min: 10,
                max: 12,
                message: "Поле должно содержать 10, или 12 цифр",
                pattern: "^([0-9]{10}|[0-9]{12})$"
              },
              { required: true, message: "Вы не указали ИНН", whitespace: true }
            ]
          })(<Input />)}
        </Form.Item>

        <Form.Item
          {...formItemLayout}
          label="Дополнительные сведения"
          validateStatus={this.validateStatusGet("Comments", false)}
          help={this.validateStatusGet("Comments", true)}
          className={styles.input}
        >
          {getFieldDecorator("Comments", {
            rules: [
              { type: "string", max: 2000, message: "Превышена максимальная длина" },
              { required: false, whitespace: true, message: "Одни лишь пробелы недопустимы" }
            ]
          })(<TextArea rows={4} />)}
        </Form.Item>

        {/* Локальная математическая капча */}
        <Form.Item
          label={
            <span>
              <span style={{ color: "red" }}>*</span>
              Проверка: Сколько будет {this.state.captchaA} + {this.state.captchaB}?
            </span>
          }
          validateStatus={this.state.isCaptchaNull ? "error" : ""}
          help={this.state.isCaptchaNull ? "Решите пример" : ""}
          className={styles.input}
        >
          <Input
            value={this.state.userCaptchaInput}
            onChange={this.onCaptchaChange}
            placeholder="Введите ответ"
          />
        </Form.Item>

        <Form.Item
          {...tailFormItemLayout}
          className={styles.input}
          style={{ paddingTop: "45px" }}
        >
          <Button
            type="primary"
            htmlType="submit"
            disabled={
              this.hasErrors(getFieldsError()) || this.state.isCaptchaNull
            }
            style={{ marginRight: "1em", float: "right" }}
          >
            Отправить
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const WrappedForm = Form.create({ name: "horizontal_login" })(
  AppForContractForm
);

export default WrappedForm;